export const POSITIVE_DELIVERY_BADGES = [
  "punctualDelivery",
  "bagInPerfectCondition",
  "professionalism",
  "quietDelivery",
] as const;

export const NEGATIVE_DELIVERY_BADGES = [
  "lateDelivery",
  "courierWokeMeUp",
  "bagOrContentsDamaged",
  "other",
] as const;

export const DELIVERY_BADGES = [
  ...POSITIVE_DELIVERY_BADGES,
  ...NEGATIVE_DELIVERY_BADGES,
];

export const getDeliveryBadgeLabelKey = (value: string): string | undefined =>
  (DELIVERY_BADGES as readonly string[]).includes(value) ? value : undefined;
